import React, { Component } from 'react';
import { Media, NavDropdown, MenuItem, Modal } from 'react-bootstrap';
import { map } from 'lodash';
import CustomModal from '../common/CustomModal';
import { timeSince } from '../../helpers';

class ReviewReply extends Component {
  constructor() {
    super()
    this.state = {
      editReply: false,
      inputVal: "",
      deleteModalVisible: false,
      readOnly: true,
      origianlReply: "",
      smallScreen:false
    }
  }

  componentDidMount() {
    this.setState({ inputVal: this.props.comments.comments, origianlReply: this.props.comments.comments });
    window.addEventListener('mousedown', this.bodyClick.bind(this));
      window.addEventListener('resize', this.updateWindowDimensions.bind(this));
      this.updateWindowDimensions()
  }
  componentWillUnmount() {
    window.removeEventListener('mousedown', this.bodyClick.bind(this));
  }
  commentReply(e) {
    this.state.editReply ? this.setState({ inputVal: e.target.value }) : "";
  }
  
  updateWindowDimensions() {
    if (window.innerWidth < 640 ) {
      this.setState({smallScreen:true});
    }
  }

  
  
  bodyClick(e) {
    if (this.state.editReply) {

      if (!e.target.closest("#reply_" + this.props.index) || e.target.closest("#reply_" + this.props.index).id != "reply_" + this.props.index) {

        this.setState({ editReply: false, inputVal: this.state.origianlReply });
      }
      if(e.target.className != "reply-editable active"){
        this.setState({ editReply: false})
      }

    }
  }
  render() {
    let { comments, commentId, index } = this.props
    let reviewDate = new Date(comments.updatedAt);
    let seconds = Math.floor((new Date() - reviewDate) / 1000);
    if (seconds > 82800) {
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let updatedAt = comments && new Date(comments.updatedAt);
      reviewDate = months[updatedAt.getMonth()] + ' ' + updatedAt.getDate() + ' , ' + updatedAt.getFullYear();
    } else {
      reviewDate = timeSince(new Date(new Date(comments.updatedAt).getTime())) + ' Ago';
    }
    return (
      <div className="reply" >
        <Media>
          <span className="time-left">{reviewDate}</span>
          <NavDropdown pullRight className="dotsDD" noCaret title={<i className="mdi mdi-dots-vertical" />} id="edit-comment">
            <MenuItem eventKey="edit" onClick={() => this.setState({ editReply: true, readOnly: false })}>Edit</MenuItem>
            <MenuItem eventKey="delete" onClick={() => {
              this.setState({ deleteModalVisible: true, readOnly: true });
            }}>Delete</MenuItem>
          </NavDropdown>
          <Media.Left>
            <img className="rating-img" src={comments && comments.profilePhoto ? comments.profilePhoto : "../../images/placeholder.png"} alt="Image" />
          </Media.Left>
          <Media.Body>
            <Media.Heading>{comments.name}</Media.Heading>
            {!this.state.smallScreen && <span id={"reply_" + index} className="reply-box">
              {!this.state.readOnly && <input className={this.state.editReply ? "reply-editable active" : "reply-editable"}
                onChange={(e) => { this.commentReply(e) }}
                type="text" value={this.state.inputVal}
              />}
              {this.state.readOnly && <p>{this.state.inputVal}</p>}
              {this.state.editReply && <span className="reply-controls">
                <i className="mdi mdi-send review-reply-send" onClick={() => {
                  //  this.props.sentReply(this.state.inputVal, commentId, index);
                  this.setState({ editReply: false, readOnly: true, origianlReply: this.state.inputVal });
                  this.props.actions.addComments(this.state.inputVal, true, commentId, comments.id);
                }} />
                {/* <i className="mdi mdi-close review-reply-close" onClick={() => this.setState({ editReply: false,readOnly:true })}></i> */}
              </span>}
            </span>}

          </Media.Body>
          {this.state.smallScreen && <span id={"reply_" + index} className="reply-box">
              
              <textarea className={this.state.editReply ? "reply-editable active" : "reply-editable hide"}
                onChange={(e) => { this.commentReply(e) }}
                type="text" value={this.state.inputVal}
              />
               <p className={this.state.editReply ?"hide":"n-rating-text"}>{this.state.inputVal}</p>
              {this.state.editReply && <span className="reply-controls">
                <i className="mdi mdi-send review-reply-send" onClick={() => {
                  this.setState({ editReply: false, readOnly: true, origianlReply: this.state.inputVal });
                  this.props.actions.addComments(this.state.inputVal, true, commentId, comments.id);
                }} />
              </span>}
            </span>}
        </Media>
        <CustomModal submitCallBack={() => {
          this.props.actions.deleteComments(comments.id, commentId);
          this.setState({ deleteModalVisible: false });
        }} showModal={this.state.deleteModalVisible} footer="true" title="save location" hideModal={() => this.setState({ deleteModalVisible: false })} cancelText="Close" saveText="Delete">
          <Modal.Body>
            <div>
              <h5 className="reply-delete-caption">Are you sure you want to delete your comment?</h5>
            </div>

          </Modal.Body>
        </CustomModal>

      </div>
    );
  }
}

export default ReviewReply;



// WEBPACK FOOTER //
// ./src/components/ReviewRating/ReviewReply.jsx